import { call, put, takeLatest } from "redux-saga/effects";
import { gachNoThuCongApi } from "../../../api/dong-bo/gachNoThuCongApi";
import { IGachNoRequest } from "../../../model/request/dong-bo/IGachNoRequest";
import { IGachNoResponse } from "../../../model/respone/dong-bo/IGachNoResponse";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eGachNoThuCongActionTypeIds,
  IGachNoThuCongActionTypes,
} from "../../action-types/dong-bo/IGachNoThuCongAction";
import { rootActions } from "../../actions/rootActions";

export function* gachNoThuCongSaga(): any {
  yield takeLatest(eGachNoThuCongActionTypeIds.GACH_NO_START, gachNoWorker);
}

function* gachNoWorker(action: IGachNoThuCongActionTypes): any {
  const request = action.payload as IGachNoRequest;
  const res: IBaseRespone = yield call(gachNoThuCongApi.GachNoThuCong, request);
  if (res.is_success) {
    var data = res.data as IGachNoResponse;
    yield put(rootActions.dongBo.gachNoThuCong.GACH_NO_SUCCESS(data));
  } else {
    yield put(
      rootActions.dongBo.gachNoThuCong.GACH_NO_ERR(res.message ?? "Có lỗi"),
    );
  }
}
